<template>
  <v-container fluid>
      <v-card>
        <v-card-title><h4>Dashboard</h4></v-card-title>
        <v-divider></v-divider>
        <product-usage-chart
          v-if="hasElements"
          :height="150"
          :elements="statistics.elements"
        />
      </v-card>
  </v-container>
</template>

<script>

import timaprkApi from '../timeparkApi';
import ProductUsageChart from './statistics/ProductUsageChart';
import constants from "@/constants";

export default {
  name: 'Dashboard',
  components: {
    ProductUsageChart,
  },
  computed: {
    hasElements() {
      return this.statistics &&
        this.statistics.elements &&
        this.statistics.elements.length > 0;
    },
  },
  mounted() {
    timaprkApi
      .getProjectsStatistics()
      .then((r) => {
        this.statistics = r.data;
        if (this.statistics.elements) {
          this.statistics.elements = this.statistics.elements.map(x => ({
            ...x,
            name: x.name ? x.name : constants.nonTimeparkTaskName,
          }));
        }
      });
  },
  data: () => ({
    statistics: null,
  }),
};
</script>
